<template>
  <div class="addvip">
   <div class="content">
      <!-- 标题 -->
    <div class="title">
      <i class="el-icon-edit"></i>
      <span>修改证书信息</span>

      <!-- 返回按钮 -->
      <div class="back">
        <el-button round size='mini' class="back-btn" icon='el-icon-arrow-left' @click="back">返回</el-button>
      </div>
    </div>
    

    <!-- 表单内容 -->
    <el-form :model="form" class="main" size="medium" status-icon label-width="120px" ref="ruleForm">

      <el-form-item label="证书名称:" prop="cert" >
        <el-input v-model="form.cert" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="证书编号:" prop="num" >
        <el-input v-model="form.num" placeholder="请输入证书编号"></el-input>
      </el-form-item>
      <el-form-item label="广西跆协证书编号:" prop="xnum" >
        <el-input v-model="form.xnum" placeholder="请输入广西跆协证书编号"></el-input>
      </el-form-item>
      <el-form-item label="身份证:" prop="tel"  >
        <el-input v-model="form.tel"  disabled></el-input>
      </el-form-item>
      <el-form-item label="证书类别:" prop="level">
        <el-input v-model="form.level" ></el-input>
      </el-form-item>
      <el-form-item label="证书日期:" prop="start">
       <el-input v-model="form.start" ></el-input>
      </el-form-item>
      <el-form-item label="证书到期:" prop="endTime" >
        <el-input v-model="form.endTime"  style="width:190px"></el-input>
        
      </el-form-item>

      <el-form-item class="control">
        <el-button type="danger" icon="el-icon-close" @click="back">取消</el-button>
        <el-button @click="resetForm()" class="reset-btn" icon="el-icon-refresh-left">重置</el-button>
        <!-- <el-button type="primary"  @click="setPwd" class="btn-setPwd">重置密码</el-button> -->
        <el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-document-add">保存</el-button>
      </el-form-item>

      
    </el-form>
   </div>
  </div>
</template>
<script>
 export default {
    data() {
      
      return {
        dialogVisible: false,
        dialogForm:{
          time:""
        },
        data:{},
        form: {},
        type:0,
        time:0
      }
    },
    methods: {
      delTime(){
        this.time=0;
        this.dialogForm.time = '';
      },
      chooseTime(){
        this.dialogVisible = false
        this.time = this.dialogForm.time;
      },
      back(){//返回房产信息列表
        this.$router.push({path:'/home/course'});
      },
  

      // 提交表单
      submitForm(formName) {
        this.form.operater=sessionStorage.getItem("tel");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$confirm("此操作会将数据永久性修改，确认是否继续操作?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(()=>{
              console.log("seccess!",this.form);
              this.axios.post('/teacher/findTel',{
                tel:this.form.tel
                //id:this.form.uid
                //role:1
              })
              .then(res=> {
                console.log(res.data);
                if(res.data.code == 0){
                  this.$message.error(res.data.msg);
                }
                else{

                  this.axios.post("/teacher/alterCert",{
                    id:this.data.no,
                    num:this.form.num,
                    xnum:this.form.xnum,
                    tel:this.form.tel,
                    cert:this.data.cert,
                    start:this.form.start,
                    level:this.form.level,
                    operater:this.form.operater,
                    endTime:this.data.endTime,
                    //time:this.time,
                    type:this.data.c_status
        
                  })
                  .then(res=>{
                    console.log(res);
                    if(res.data.code=='200'){
                      this.$message.success(res.data.msg);
                      this.$router.push({path:'/home/course'});
                    }
                  })
                  .catch(err=>{
                   this.$message.error(err);
                  })
                }
              })
              .catch(err=>{
               this.$message.error(err);
              })
              
            })
            .catch(()=>{
              this.$message.info("已取消修改");
            })
            

            
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },

      // 重置表单
      resetForm() {
        // this.$refs[formName].resetFields();
        this.form=this.formateData(this.data);
      },

      // 格式化数据
      formateData(item){
        var data={};
       
        data.no=item.c_id
        data.tel=item.m_idNum
        data.cert=item.c_cert
        data.level=item.c_level
        data.start=this.switchTimeFormat(item.c_startDate)
        //data.endTime=this.switchTimeFormat(item.c_endDate)
        data.endTime = item.c_endDate?this.switchTimeFormat(item.c_endDate):null;
        data.num=item.c_num
        data.xnum=item.c_gxnum
        data.operater=item.operater
        data.c_status=item.c_status
         console.log(data);
        return data;
      },

      // 格式化时间
      switchTimeFormat(time) {
        const dateTime = new Date(time);
        const year = dateTime.getFullYear();
        const month = dateTime.getMonth() + 1;
        const date = dateTime.getDate();
        return `${year}-${this.PrefixInteger(month,2)}-${this.PrefixInteger(date,2)}`;
      },

      // 格式化数字
      PrefixInteger(num, n) {
        return (Array(n).join(0) + num).slice(-n);
      },

      // 成为会员
      setVip(){
        this.dialogVisible=true;
      },

      
    },

    mounted() {//创建时获取数据
      console.log(this.$route.params.id);
      this.axios.post("/teacher/getCertDetail", {
        id:this.$route.params.id
      })
      .then((res) => {
        console.log(res);
        if(res.data.code=='200'){
          this.loading=false;
          this.data = res.data.data;
          this.data= this.formateData(this.data);
          this.form=this.data;
        }
      })
      .catch(err=> {
        console.log(err);
      })
    },
  }
</script>
<style lang="less" scoped>
@import "../assets/less/base.less";
.tiem-msg{
  display: inline-block;
  border-radius: 5px;
  margin-left: 10px;
  padding: 0 10px;
  line-height: 36px;
  color:white;
  background: @yellowColor;
  span{
    margin-left: 10px;
  }
}
.addvip {
  color: @fontColor;
  background-color: white;
  min-height: 500px;
}
.content {
  background: white;
}
.title {
  padding: 15px 20px;
  border-top: 3px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
  i {
    margin-right: 2px;
  }
  .back {
    float: right;
    .back-btn{
      padding: 5px;
    }
  }
}
.main{
  padding: 20px;
}
.el-input--medium,.el-select,.time-input{
  width: 300px;
}
.reset-btn{
  background: @blueGreenColor;
  color: white;
  border-color: @blueGreenColor;
}
.el-form--inline .control{
  text-align: right;
  width: 100%;
}
.btn-setPwd{
  background: @yellowColor;
  border-color: @yellowColor;
}
</style>